export default __webpack_public_path__ + "static/media/handshake.7e9096d1.svg";